import { get, getBlob, post, toQueryParams } from '@/lib/http';
import { endpoints } from './endpoints';
import type {
  GenerateQrRequest,
  GenerateQrResponse,
  Page,
  PageRequest,
  QrBatch,
  QrCode,
  QrStatus,
} from '@/types';

export interface QrQuery extends PageRequest {
  batchId?: number;
  poId?: number;
  buyerId?: number;
  status?: QrStatus | 'ALL';
  search?: string;
}

export interface QrBatchQuery extends PageRequest {
  buyerId?: number;
  poId?: number;
  search?: string;
}

export const qrApi = {
  generate: (body: GenerateQrRequest) =>
    post<GenerateQrResponse, GenerateQrRequest>(endpoints.qr.generate, body),

  list: (query: QrQuery = {}) =>
    get<Page<QrCode>>(endpoints.qr.list, { params: toQueryParams({ page: 0, size: 10, ...query }) }),

  byCode: (code: string) => get<QrCode>(endpoints.qr.byCode(code)),

  batches: (query: QrBatchQuery = {}) =>
    get<Page<QrBatch>>(endpoints.qr.batches, {
      params: toQueryParams({ page: 0, size: 10, ...query }),
    }),

  /**
   * Label sheet PDF. The mock returns a small placeholder blob; on the Spring
   * side this is typically an `iText`/`OpenPDF` stream with
   * `Content-Disposition: attachment`.
   */
  labelsPdf: (batchId: number) => getBlob(endpoints.qr.batchPdf(batchId)),

  cancel: (code: string) => post<QrCode>(endpoints.qr.cancel(code)),
};
